import BaseMixin from './BaseMixin'
export default {
  mixins: [BaseMixin],
  methods: {
      crudRecuperar(id, options){
        this._validate()
        return this.$axios.$get(`${this.pathApi}/${id}`, options)
          .then((resp) => {
            this.dados = resp
          });
      }
  }
}
